
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#000","d":"M4 21.033h39.1L34.463 10.6h-21.23zM4 22l19.24 21.928L42.912 22z"}}),_c('path',{attrs:{"stroke":"#000","d":"M20.846 10.6L13 21.016h20.965L26.845 10.6zM13 22l10.371 21.6L33.554 22z"}}),_c('path',{attrs:{"fill":"#1FABA5","d":"M23.834 24.096v14.849l5.926-14.85zM21.055 13L16 20.014h5.695v-6.357z"}}),_c('g',{attrs:{"stroke":"#1FABA5"}},[_c('path',{attrs:{"d":"M36.833 4.116c1.342 1.487 2.755 1.489 4.238.005M41.783 9.066c-1.486-1.342-1.488-2.754-.005-4.238M41.066 9.783c-1.342-1.486-2.754-1.488-4.238-.005M36.116 4.833c1.487 1.342 1.489 2.755.005 4.238"}})])])])
          )
        }
      }
    